export default __webpack_public_path__ + "static/media/tag.b9c3dabc.svg";